namespace SP {
    export enum PeriodDateType {
        CreatedAt = 1,
        FinishedAt = 2,
        UpdatedAt = 3,
        CancelledAt = 4,
    }
}